module.exports = __webpack_public_path__ + "img/expand-wide.d06ea39c.svg";